import React from 'react';
import { isSet } from '../../../../Utils/CommonFunctions';
// import elementsProperties from './elementsProperties';


const InputText = (props)=>{
    const {path,keyParam,elementData,label} = props;
    let scmInputValue = (isSet(elementData.attributes[`${keyParam}`],null)!==null)?elementData.attributes[`${keyParam}`]:'';
    

    const changeHandler = (e) => {
        const {value} = e.target;                
        props.changeHandler(path,keyParam,value);        
    } 

    return(
        <div className="w-100">
            <div className="input-group mb-3">  
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>{label}</span>
                </div>              
                <input type="text" className="form-control" value={scmInputValue} onChange={e=>changeHandler(e)} />                
            </div>
                      
        </div>
    )
}


export default InputText;